import Grid from '@mui/material/Grid';
import * as React from 'react';

export interface IconBoxProps {
  children: React.ReactNode;
  icon: React.ReactNode;
  withoutMargin?: boolean;
}

export function IconBox({ children, icon, withoutMargin }: IconBoxProps) {
  return (
    <Grid alignItems={!withoutMargin ? 'center' : undefined} container spacing={1} wrap="nowrap">
      <Grid size="auto" sx={!withoutMargin ? { mt: 1 } : undefined}>
        {icon}
      </Grid>
      <Grid size="auto" textAlign={'left'}>
        {children}
      </Grid>
    </Grid>
  );
}
